import { ComponentProps, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '@alltrails/denali/components/Link';
import Typography from '@alltrails/core/components/Typography';
import logLogInScreenForgotPasswordTapped from '@alltrails/amplitude/events/logLogInScreenForgotPasswordTapped';
import TermsOfService from '../TermsOfService';
import EmailPasswordLogin from '../EmailPasswordLogin';
import AltLoginsForm from '../AltLoginsForm';
import LoginResponse from '../../types/LoginResponse';
import styles from './SignUpModal.module.scss';

// Desktop: https://app.zeplin.io/project/6218dc5177101a641929be50/screen/6218e13d32440b60dea65769
// Mobile: https://app.zeplin.io/project/6218dc5177101a641929be50/screen/6218dec5dccf0d54f6dee4f4

type LogInProps = Pick<ComponentProps<typeof AltLoginsForm>, 'appleLoginHandler' | 'facebookLoginHandler' | 'googleLoginHandler'> & {
  grantType?: string | null;
  heading?: ReactNode;
  handleLoginSuccess: ({ user }: LoginResponse) => void;
};

const LogIn = ({ grantType, heading, handleLoginSuccess, ...loginHandlers }: LogInProps) => {
  return (
    <div className={styles.content}>
      <Typography component="div" variant="heading400" mb="24">
        {heading || (
          <>
            <FormattedMessage defaultMessage="Welcome back." />
            <br />
            <FormattedMessage defaultMessage="Log in and start exploring." />
          </>
        )}
      </Typography>
      <div className={styles.login}>
        <div className={styles.form}>
          <EmailPasswordLogin grantType={grantType} handleLoginSuccess={handleLoginSuccess} />
        </div>
        <Typography component="div" variant="paragraph200">
          <Link
            href="/users/password/new"
            onClick={() => {
              logLogInScreenForgotPasswordTapped();
            }}
            outsideOfMugen
          >
            <FormattedMessage defaultMessage="Forgot your password?" />
          </Link>
        </Typography>
        <AltLoginsForm {...loginHandlers} authType="login" />
        <TermsOfService />
      </div>
    </div>
  );
};

export default LogIn;
